import { sites as siteMessages } from './validationMessages';

/**
 * Detect JSON payloads that are a successful-but-empty "sites" list (e.g. {"sites":[]}).
 * Those should not be shown as raw text or toast — use a friendly empty state instead.
 */
export function shouldSuppressAsRawAiSitesPayload(raw) {
  if (raw == null || typeof raw !== 'string') return false;
  const t = raw.trim();
  if (!t.startsWith('{')) return false;
  try {
    const o = JSON.parse(t);
    if (!o || typeof o !== 'object') return false;
    return Array.isArray(o.sites) && o.sites.length === 0;
  } catch {
    return false;
  }
}

/**
 * Maps AI suggested-sites API/backend text to a validation message from validationMessages.
 * Any unrecognized or technical text uses sites.aiSuggestionUnableToComplete.
 */
export function resolveAiSuggestedSitesUserFacingMessage(rawInput, options = {}) {
  const rawStr = typeof rawInput === 'string' ? rawInput.trim() : String(rawInput ?? '').trim();
  const httpStatus = options.httpStatus;

  if (httpStatus === 503) {
    return siteMessages.aiIntegratedSourceUnavailable;
  }
  if (/status code\s*503/i.test(rawStr)) {
    return siteMessages.aiIntegratedSourceUnavailable;
  }

  if (!rawStr) {
    return siteMessages.aiSuggestionUnableToComplete;
  }

  const isIntegratedSourceMsg = rawStr === siteMessages.aiIntegratedSourceUnavailable;
  const looksLikeProviderError =
    isIntegratedSourceMsg ||
    /API error|ServiceUnavailable|UNAVAILABLE|"code"\s*:\s*503/i.test(rawStr);

  if (looksLikeProviderError) {
    return siteMessages.aiIntegratedSourceUnavailable;
  }

  if (/AI site suggestion is not enabled/i.test(rawStr)) {
    return siteMessages.aiSuggestionNotEnabled;
  }

  if (rawStr === 'No content in AI response.' || rawStr === 'Empty AI response.') {
    return siteMessages.aiSuggestionEmptyResponse;
  }

  return siteMessages.aiSuggestionUnableToComplete;
}
